$('body').on('click', 'form .checkAll', function () {
  var opts = $(this).metadata().checkAllOpts;
  $(opts.targetSelector + ' input:checkbox').prop(
    'checked',
    $(this).is(':checked')
  );
});
